import { AutoModeOutlined, DarkModeOutlined, LightModeOutlined, ParkOutlined, SpaOutlined } from '@mui/icons-material';

import via3Logo from 'assets/images/via3-logo.png';
import via3LogoLight from 'assets/images/via3-logo-light.png';

import { ThemePreference } from './themePreference';

export type ThemeOption = {
  mode: ThemePreference;
  label: string;
};

export const visibleThemePreferences: ThemePreference[] = ['light', 'dark', 'system', 'calm', 'nature'];

export const getVisibleThemePreference = (mode: ThemePreference): (typeof visibleThemePreferences)[number] => {
  return visibleThemePreferences.includes(mode) ? mode : 'light';
};

export const createThemeOptions = (labels: Record<ThemePreference, string>): ThemeOption[] => {
  return [
    { mode: 'light', label: labels.light },
    { mode: 'dark', label: labels.dark },
    { mode: 'system', label: labels.system },
    { mode: 'calm', label: labels.calm },
    { mode: 'nature', label: labels.nature },
  ];
};

export const renderThemeIcon = (mode: ThemePreference, className?: string) => {
  switch (mode) {
    case 'dark':
      return <DarkModeOutlined className={className} />;
    case 'system':
      return <AutoModeOutlined className={className} />;
    case 'calm':
      return <SpaOutlined className={className} />;
    case 'nature':
      return <ParkOutlined className={className} />;
    case 'light':
    default:
      return <LightModeOutlined className={className} />;
  }
};

export const getHipaaLogoSrc = (mode: 'light' | 'dark' | 'calm' | 'nature'): string => {
  switch (mode) {
    case 'dark':
      return '/logo-dark.svg';
    case 'calm':
      return '/logo-calm.svg';
    case 'nature':
      return '/logo-nature.svg';
    case 'light':
    default:
      return '/logo.svg';
  }
};

export const getVia3LogoSrc = (mode: 'light' | 'dark' | 'calm' | 'nature'): string => {
  switch (mode) {
    case 'dark':
      return via3LogoLight;
    case 'calm':
      return '/via3-logo-calm.png';
    case 'nature':
      return '/via3-logo-nature.png';
    case 'light':
    default:
      return via3Logo;
  }
};
